import { BYSTADIUM_MARKETING_URL, BYSTADIUM_HOSTNAME } from "./app-routes";

export const getMarketingCtaLink = ({ isAuthenticated, path }) => {
  const origin = isAuthenticated ? BYSTADIUM_MARKETING_URL : BYSTADIUM_HOSTNAME;
  return `${origin}/${path}`;
};
